import { render, staticRenderFns } from "./basicMsg.vue?vue&type=template&id=5c3ab410&scoped=true"
import script from "./basicMsg.vue?vue&type=script&lang=js"
export * from "./basicMsg.vue?vue&type=script&lang=js"
import style0 from "./basicMsg.vue?vue&type=style&index=0&id=5c3ab410&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3ab410",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c3ab410')) {
      api.createRecord('5c3ab410', component.options)
    } else {
      api.reload('5c3ab410', component.options)
    }
    module.hot.accept("./basicMsg.vue?vue&type=template&id=5c3ab410&scoped=true", function () {
      api.rerender('5c3ab410', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/components/basicMsg.vue"
export default component.exports